import script from "./MessageCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./MessageCarousel.vue?vue&type=style&index=0&id=2e53d77d&lang=scss"

const __exports__ = script;

export default __exports__